export const CreditHistoryColumns = [
  {
    accessor: "createDateTime",
    Header: "زمان انجام",
    header: "زمان انجام",
    key: "createDateTime",
  },
  {
    accessor: "author",
    Header: "شخص",
    header: "شخص",
    key: "author",
  },
  {
    accessor: "creditExpirationDate",
    Header: "تاریخ تسویه جدید",
    header: "تاریخ تسویه جدید",
    key: "creditExpirationDate",
  },
]
